/// <amd-module name="TFS/Admin/Common/Util/SendToastUtility" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IGlobalMessagesService } from "TFS/GlobalBanner/GlobalMessagesService";

const toastDuration: number = 5000;

export function sendToast(message: string, pageContext: IVssPageContext) {
    const toastService = pageContext.getService<IGlobalMessagesService>("IGlobalMessagesService");
    toastService && toastService.addToast({ message, duration: toastDuration });
}
